import styled from '@emotion/styled';
import ArrowNext from '@engineering/icons/arrow-next';
import { Button } from '@silvertours/front-shared';
import { lighten, desaturate } from 'polished';

const StyledArrowNext = styled(ArrowNext)`
  fill: currentcolor;
  width: 100%;
  height: auto;
  display: flex;
`;

const CallToAction = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 0;
  color: ${({ theme }) => theme.color.white};
  background-color: ${({ theme }) => theme.color.brand};
  fill: currentcolor;
  width: 3.25rem;
  height: inherit;
  cursor: pointer;
  border-radius: 0;
  border-left: ${({ theme }) => `${theme.color.grey04} 1px solid`};
  margin-top: -1px;
  padding: ${({ theme }) => theme.spacing[30]};
`;

const Container = styled.div<{ hasAction: boolean }>`
  height: 100%;
  border: ${({ theme }) => `${theme.color.grey04} 1px solid`};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  background-color: ${({ theme }) => theme.color.white};
  cursor: ${({ hasAction }) => (hasAction ? 'pointer' : 'initial')};
  overflow: hidden;

  &:hover ${CallToAction} {
    background-color: ${({ theme }) =>
      desaturate(0.3, lighten(0.11, theme.color.brand!))};
  }
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[50]};
  padding: ${({ theme }) => theme.spacing[40]};
`;

const PriceWrapper = styled.div`
  font-weight: 600;
`;

const Price = styled.span`
  font-size: ${props => props.theme.fontSize.md.size};
`;

const PerDay = styled.span`
  font-weight: normal;
`;

const Headline = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const CarCategory = styled.div`
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
`;

const CityWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing[40]};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[30]};
`;

const Footer = styled.div`
  font-size: ${props => props.theme.fontSize.sm.size};
  border-top: ${({ theme }) => `${theme.color.grey04} 1px solid`};
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
`;

const ImageWrapper = styled.div`
  display: flex;
  position: relative;
  height: 130px;
  width: 100%;

  ${({ theme }) => theme.mq('lg')} {
    height: 150px;
  }
`;

const CarAttributes = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[50]};
`;

const CarAttribute = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

const StyledIcon = styled.div`
  width: ${({ theme }) => theme.spacing[50]};
  height: ${({ theme }) => theme.spacing[50]};
`;

export {
  Container,
  ImageWrapper,
  Headline,
  CarCategory,
  Body,
  CarAttributes,
  CarAttribute,
  StyledIcon,
  Footer,
  CityWrapper,
  PriceWrapper,
  Price,
  PerDay,
  CallToAction,
  StyledArrowNext,
};
